function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "m275.565 0c-151.955 0-275.565 123.608-275.565 275.565 0 151.955 123.61 275.565 275.565 275.565s275.565-123.61 275.565-275.565c0-151.957-123.61-275.565-275.565-275.565zm-241.119 275.565c0-60.286 22.399-115.337 59.107-157.659l339.671 339.671c-42.321 36.708-97.372 59.107-157.659 59.107-132.949 0-241.12-108.17-241.119-241.119zm423.133 157.659-339.671-339.671c42.321-36.708 97.372-59.107 157.659-59.107 132.949 0 241.119 108.17 241.119 241.119 0 60.286-22.399 115.338-59.107 157.659z"
});

var SvgDisabled = function SvgDisabled(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 551.13 551.13",
    height: 512,
    viewBox: "0 0 551.13 551.13",
    width: 512,
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDisabled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/disabled.35370023.svg";
export { ForwardRef as ReactComponent };